import { defineElement, html, TemplateElement, when } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-slider-group/e-banking-slider-group.js';
import { mapNodes } from '@/mgnl/utils/magnolia.js';

class EditableSliderGroup extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { mgnlContext: null };
    }

    template() {
        return html`
            ${when(
                !this.mgnlContext?.isMagnoliaEdit,
                html`<mb-e-banking-slider-group>
                    ${mapNodes(this.content?.sliderElements).map((content, index) => {
                        return html`<mgnl-editable-component
                            slot="slide-${index}"
                            .content="${content}"
                        ></mgnl-editable-component>`;
                    })}
                </mb-e-banking-slider-group>`,
                html`<mgnl-editable-area .content="${this.content?.sliderElements}"></mgnl-editable-area>`,
            )}
        `;
    }
}

defineElement('editable-slider-group', EditableSliderGroup);
